import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Typography, Box } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SummarizeIcon from '@mui/icons-material/Summarize';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

interface BreadcrumbProps {
  currentStep: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ currentStep }) => {
  const steps = [
    { label: 'Vehicles', icon: <ElectricCarIcon sx={{ mr: 0.5 }} fontSize="small" /> },
    { label: 'Locations', icon: <LocationOnIcon sx={{ mr: 0.5 }} fontSize="small" /> },
    { label: 'Summary', icon: <SummarizeIcon sx={{ mr: 0.5 }} fontSize="small" /> },
    { label: 'Quotes', icon: <RequestQuoteIcon sx={{ mr: 0.5 }} fontSize="small" /> }
  ];

  return (
    <Box 
      sx={{ 
        bgcolor: 'background.paper',
        py: 3,
        px: 2,
        boxShadow: 1,
        borderRadius: 1,
        mb: 3
      }}
    >
      <MuiBreadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {steps.map((step) => {
          const isCurrentStep = currentStep === step.label;
          
          return (
            <Typography
              key={step.label}
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: isCurrentStep ? 'primary.main' : 'text.secondary',
                fontWeight: isCurrentStep ? 'bold' : 'regular',
                fontSize: '0.875rem',
                cursor: 'default'
              }}
            >
              {step.icon}
              {step.label}
            </Typography>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
